import React, {useEffect, useState} from "react";
import NavBar from "../../Component/NavBar/NavBar";
import {IoIosAddCircleOutline} from "react-icons/io";
import apiRequests from "../../Component/axios/config/config";
import Loading from "../../Component/Loading/Loading";
import toast from "react-hot-toast";
import {BiSolidUserDetail} from "react-icons/bi";
import {FaEye, FaEyeSlash, FaTrash} from "react-icons/fa";
import {useNavigate} from "react-router-dom";

export default function Admins() {
    const [admins, setAdmins] = useState([]);
    const [loading, setLoading] = useState(true);
    const [showAddModal, setShowAddModal] = useState(false);
    const [searchQuery, setSearchQuery] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const [deleteLoading, setDeleteLoading] = useState({status: false, id: null});
    const navigate = useNavigate();

    function apiGetAdmins(page) {
        setLoading(true);
        const params = {
            page,
            limit: 10,
        };

        if (searchQuery) {
            params.search = searchQuery;
        }
        apiRequests
            .get("/api/admin/v1/get-admin-list",{params})
            .then((response) => {
                setAdmins(response.data.data);
            })
            .catch((err) => {
                if (err.status === 401 || err.status === 403) {
                    navigate("/login");
                }
            })
            .finally(() => setLoading(false));
    }


    useEffect(() => {
        apiGetAdmins(currentPage);
    }, [currentPage, searchQuery]);

    function deleteAdmin(id) {
        setDeleteLoading({...deleteLoading, status: true, id: id});
        apiRequests.delete(`/api/admin/v1/delete-by-admin/${id}`)
            .then(() => {
                toast.success("Admin successfully deleted");
                window.location.reload();
            })
            .catch(() => {
                toast.error("Error deleting admin");
            })
            .finally(() => setDeleteLoading({...deleteLoading, status: false, id: null}));
    }

    return (
        <div className="p-6">
            <div className="text-3xl font-bold text-gray-800 mb-6">
                Admins Management
            </div>

            <NavBar
                item={[
                    {
                        icon: <BiSolidUserDetail style={{fontSize: "22px"}}/>,
                        title: "All Admins",
                    },
                    {
                        icon: <IoIosAddCircleOutline/>,
                        title: "Add Admin",
                        onClick: () => setShowAddModal(true),
                    },
                ]}

                onSearch={(value) => {
                    setSearchQuery(value);
                    setCurrentPage(1);
                }}
            />

            <div className="flex justify-center mt-8">
                <div className="w-full max-w-6xl md:overflow-x-auto">
                    <table className="w-full bg-white shadow-md rounded-lg">
                        <thead
                            className="bg-gradient-to-r text-left from-buttonColor-shade4 to-marginColor-shade9 text-white">
                        <tr>
                            <th className="px-4 py-2 text-md font-medium rounded-tl-lg">
                                First Name
                            </th>
                            <th className="px-4 py-2 text-md font-medium">Last Name</th>
                            <th className="px-4 py-2 text-md font-medium">Username</th>
                            <th className="px-4 py-2 text-md font-medium text-center rounded-tr-lg">Action</th>
                        </tr>
                        </thead>
                        <tbody className="bg-white divide-y divide-gray-200">
                        {loading ? (
                            <tr>
                                <td className="px-4 py-3 text-center" colSpan="4">
                                    <Loading/>
                                </td>
                            </tr>
                        ) : admins.length > 0 ? (
                            admins.map((item) => (
                                <tr key={item._id}>
                                    <td className="px-4 py-2 text-md font-medium">
                                        {item.firstName || "-"}
                                    </td>
                                    <td className="px-4 py-2 text-md font-medium">
                                        {item.lastName || "-"}
                                    </td>
                                    <td className="px-4 py-2 text-md font-medium">
                                        {item.userName || "-"}
                                    </td>
                                    <td className="px-4 py-2 text-md font-medium text-center">
                                        {deleteLoading.id === item._id && deleteLoading.status ? (
                                            <Loading />
                                        ) : (
                                            <button
                                                className="text-red-600"
                                                onClick={() => deleteAdmin(item._id)}
                                            >
                                                <p className="md:hidden">
                                                    Delete Admin
                                                </p>
                                                <FaTrash className="hidden md:flex" />
                                            </button>
                                        )}
                                    </td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td className="px-4 py-3 text-center" colSpan="4">
                                    No admins found!
                                </td>
                            </tr>
                        )}
                        </tbody>
                    </table>

                </div>
            </div>


            {showAddModal && (
                <ModalAddAdmin setShow={setShowAddModal} apiGetAdmins={apiGetAdmins}/>
            )}
        </div>
    );
}

export function ModalAddAdmin({setShow, apiGetAdmins}) {
    const [loadingCreate, setLoadingCreate] = useState(false);
    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");
    const [userName, setUserName] = useState("");
    const [password, setPassword] = useState("");
    const [showPassword, setShowPassword] = useState(false);

    function CreateAdmin() {

        if (userName === "" && password === "" && firstName === "" && lastName === "") {
            return toast.error("Please fill all fields");
        }
        if (userName.length < 5) {
            return toast.error("Please enter at least 5 characters for user name");
        }
        const data = {
            firstName,
            lastName,
            userName,
            password,
        };
        setLoadingCreate(true);

        apiRequests
            .post("/api/admin/v1/register-admin", data)
            .then((res) => {
                toast.success(res.data.en_message || "Admin created successfully!");
                setShow(false);
                apiGetAdmins();
            })
            .catch(() => {
            })
            .finally(() => setLoadingCreate(false));
    }

    return (
        <div className="report-modal fixed inset-0 bg-black bg-opacity-60 md:overflow-y-auto transition-opacity">
            <div className="flex min-h-full items-end justify-center p-3 text-center">
                <div
                    className="modal relative text-black transform overflow-hidden rounded-lg bg-white p-8 w-[60%] md:w-[90%] m-auto flex flex-col gap-5">
                    <div className="grid grid-cols-2 md:flex md:flex-col gap-6 text-gray-500 justify-center">
                        <div className="mt-4">
                            <label className="block mb-2 text-left font-medium">
                                First Name *
                            </label>
                            <input
                                required
                                placeholder="Enter first name"
                                className="w-full p-2 border rounded-lg text-gray-900"
                                value={firstName}
                                onChange={(e) => setFirstName(e.target.value)}
                            />
                        </div>

                        <div className="mt-4">
                            <label className="block mb-2 text-left font-medium">
                                Last Name *
                            </label>
                            <input
                                required
                                placeholder="Enter last name"
                                className="w-full p-2 border rounded-lg text-gray-900"
                                value={lastName}
                                onChange={(e) => setLastName(e.target.value)}
                            />
                        </div>

                        <div className="mt-4">
                            <label className="block mb-2 text-left font-medium">
                                Username *
                            </label>
                            <input
                                required
                                placeholder="Enter username"
                                className="w-full p-2 border rounded-lg text-gray-900"
                                value={userName}
                                onChange={(e) => setUserName(e.target.value)}
                            />
                        </div>

                        <div className="mt-4 relative">
                            <label className="block mb-2 text-left font-medium">
                                Password *
                            </label>
                            <input
                                required
                                type={showPassword ? `text` : `password`}
                                placeholder="Enter password"
                                className="w-full p-2 border rounded-lg text-gray-900"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                            />
                            <div className="absolute top-11 right-4">
                                {showPassword ? (
                                    <FaEye className="cursor-pointer" onClick={() => setShowPassword(!showPassword)} />
                                ) : (
                                    <FaEyeSlash className="cursor-pointer" onClick={() => setShowPassword(!showPassword)} />
                                )}
                            </div>
                        </div>
                    </div>

                    <div className="flex justify-center items-center gap-5 mt-8">
                        <button
                            className="px-6 py-1 border-2 border-firstColor-shade4 rounded-lg"
                            onClick={CreateAdmin}
                        >
                            {loadingCreate ? <Loading/> : "Create Admin"}
                        </button>

                        <button
                            className="hover:bg-gray-300 border-2 px-4 py-1 rounded-lg"
                            onClick={() => setShow(false)}
                        >
                            Cancel
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}
